<div class="uilab-main-canvas">
    @if (loading$ | async) {
        <app-page-blockframe></app-page-blockframe>
    }

    @if (!(loading$ | async)) {
        <ng-container>
            <div class="page-title">
                <h1>What's new</h1>
                <img [src]="headerImage" alt="Announcements header icon" />
            </div>
            @for (post of posts; track $index) {
                <div class="post">
                    <h2>{{ post.title }}</h2>
                    <p class="instance uilab-typography--subtitle2">
                        {{ post.date | date: 'longDate' }}
                    </p>
                    <app-inner-content
                        [content]="post.content"
                    ></app-inner-content>
                </div>
            }
            @if (error) {
                <app-error [error]="error"></app-error>
            }
        </ng-container>
    }
</div>
